import { useIntl } from 'react-intl';

import { KB_BASE_URL } from '@/shared/config';
import { trackEvent } from '@/shared/lib';
import { Icon } from '@/shared/ui';

import { i18n as kbI18n } from '@/widgets/KnowledgeBase/config';
import {
  openKnowledgeBase,
  useKbAvailability,
} from '@/widgets/KnowledgeBase/model';

import { ICON_SIZE, MOBILE_ICON_SIZE } from '../../config';

import styles from './LearningHub.module.scss';

type LearningHubProps = {
  isMobile?: boolean;
};

export const LearningHub = (props: LearningHubProps) => {
  const intl = useIntl();
  // null while the availability probe is in flight.
  const isAvailable = useKbAvailability();

  // No hub configured, or the content service not answering: the entry stays
  // hidden rather than dead-ending. A build without a region still shows it:
  // the panel offers a market picker in place of the fixed label.
  if (!KB_BASE_URL || !isAvailable) {
    return null;
  }

  return (
    <button
      type="button"
      className={styles.studyIcon}
      data-component="learning-hub-link"
      onClick={() => {
        trackEvent({
          eventName: 'AllPagesKnowledgeBaseIconClicked',
        });

        openKnowledgeBase();
      }}
      aria-label={intl.formatMessage(kbI18n.open)}
    >
      <Icon name="study" size={props.isMobile ? MOBILE_ICON_SIZE : ICON_SIZE} />
    </button>
  );
};
